import * as React from "react";
import useStore, { userSelector } from "../store";

export const useIsFlaggaAdmin = () => {
	const currentUser = useStore(userSelector);
	const isFlaggaAdmin = React.useMemo(() => !!currentUser && currentUser.user["flagga-admin"], [currentUser]);
	return { currentUser, isFlaggaAdmin };
};
